import { FC } from 'react';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';
import Link from '@base/lib/ThemeLink';
import { RouteEnum } from 'pro/config/routers';
import HeaderBarDropdown, { HeaderBarMenuProps } from '@app/common/PageHeader/HeaderBarDropdown';
import { useTrans } from 'base/utils/i18n';
import { useStoreState } from 'base/store';

const getGuideList = (country: string) => {
    return [
        {
            text: 'web_help_technical_guide',
            href: RouteEnum.TECHNICAL_GUIDE
        },
        {
            text: 'web_help_growing_guide',
            href: country === 'DE' ? RouteEnum.BLOG_DE : RouteEnum.BLOG
        },
    ]
}

const Menu: FC<HeaderBarMenuProps> = ({ onClose }) => {
    const { t } = useTrans();
    const { country } = useStoreState('rootStore');
    const guideList = getGuideList(country);

    return (
        <div className={styles['widget-links']}>
            {guideList.map(item => !item ? null : (
                <Link key={item.text} href={item.href}>
                    <a onClick={onClose}>
                        {t(item.text)}
                    </a>
                </Link>
            ))}
        </div>
    )
};

const HeaderGuide: FC = () => {
    const { t } = useTrans();
    return (
        <HeaderBarDropdown
            triggerProps={{ content: t('web_help_title_guide') }}
            menu={<Menu/>}
            placement="bottom"
        />
    )
};

export default HeaderGuide;
